<script lang="ts" setup>
import { useI18n } from '@/plugins/i18n'
import { computed } from 'vue'
import { MY_COLLECTION_NAME } from '@/components/Search/constants.ts';
import DocumentStatus from '@/components/common/DocumentStatus/index.ce.vue'
import { getDocumentStatus } from '@/components/common/DocumentStatus/documentStatus'

// emits
const emit = defineEmits(['handleProductLinkClick']);

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance


//props
interface Props {
  item: any,
  searchContext?: string,
  docOffset: number,
  activeCollectionName: string
}

const props = withDefaults(defineProps<Props>(), {
  item: {},
  searchContext: '',
  docOffset: 0,
  activeCollectionName: ''
})

const languages = computed(() => {
  return props.item.languages ? props.item.languages.split(',') : []
})
const MAX_HISTORIC_VERSIONS = 10;
const historicVersionsList = (item: any) => {
  let historicVersions: any = [];
  if(item.historic_versions) {
    if (item.historic_versions.length === 0) {
        return historicVersions;
    }
    historicVersions = item.historic_versions.filter(
      (version: any) => version.version_id !== item.docVersionId
    );
  }
  return historicVersions;
}
const getMaxHistoricVersionList = (item: any) => {
    const historicVersions = historicVersionsList(item).slice(0, MAX_HISTORIC_VERSIONS);
    return historicVersions;
}
const hasMoreThanMaxHistoricVersions = (item: any) => {
    return historicVersionsList(item).length > MAX_HISTORIC_VERSIONS;
}

</script>
<template>
    <div class="doc-details">
        <div class="doc-details-doc-info">
          <div class="doc-details--number result-title">
            <!-- need to implement the offset login instead of hardcoded 0 -->
            <a v-bind:href="'/management/display/index/'+ docOffset + '/' + item.doc_id + '/-/' + searchContext"
              @click="emit('handleProductLinkClick')">
              {{ item.name }}
            </a>
          </div>
          <div class="doc-details--description">{{item.title}}</div>
          <div v-if="item.subtitle" class="doc-details--subtitle">{{ item.subtitle }}</div>
          <div v-if="item.collection && item.collection === 'Y' && activeCollectionName.toLowerCase() == MY_COLLECTION_NAME.toLowerCase()" class="doc-details--collections">
            <div class="collection-label">{{ t('inMyCollection') }}</div>
          </div>
          <div v-if="getMaxHistoricVersionList(item).length > 0" class="doc-details--historic-versions">
            <div class="result-sub-title">{{ t('historic_versions') }}</div>
            <div class="doc-details--historic-versions-list">
              <template v-for="(version, index) in getMaxHistoricVersionList(item)">
                <a class="doc-details--version" :href="'/management/display/version/' + version.version_id + '/' + item.doc_id">
                  {{ version.version }}
                </a>
              </template>
              <template v-if="hasMoreThanMaxHistoricVersions(item)">
                <span class="more-versions-indicator">... </span>
              </template>
            </div>
          </div>
          <div class="doc-details--languages">
            <div v-for="language in languages" class="doc-details--language language-label">{{ language }}</div>
          </div>
        </div>
        <div class="doc-details--version-info">
          <div class="doc-details--latest-version">
            <div class="result-sub-title">{{ t('version') }}</div>
            <div v-if="item.docVersionId == 0 && item.version?.version" class="doc-details--version">{{ item.version.version }}</div>
            <div v-else-if="item.version?.version" class="doc-details--version">
              <a v-bind:href="'/management/display/version/' + item.docVersionId + '/' + item.doc_id + '/-/' + searchContext" class="linkname">
                {{ item.version.version }}
              </a>
            </div>
          </div>
          <div class="doc-details--status">
            <DocumentStatus v-if="getDocumentStatus(item)" :presentation="getDocumentStatus(item)!" />
          </div>
        </div>
    </div>
</template>
